import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

const CardsWrapper = ({ sx, ...rest }: BoxProps) => (
	<Box
		sx={combineSx(
			{
				display: {
					xs: 'flex',
					sm: 'grid',
				},
				flexDirection: 'column',
				gridTemplateColumns: 'repeat(auto-fill, minmax(336px, 1fr))',
				gap: 200,
			},
			sx,
		)}
		{...rest}
	/>
);

export default CardsWrapper;
